import { render } from "./Frequency.vue?vue&type=template&id=690b6847"
import script from "./Frequency.vue?vue&type=script&lang=js"
export * from "./Frequency.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__